@if (processorDrivers$ | async; as drivers) {
  <div class="heading-container">
    <h1 class="p-5 border-bottom {{getAppThemeName() === 'nb' ? 'nb-title' : ''}}">
      {{ 'PERMISSION_GRANT.heading_1' | translate }}
    </h1>
    @if (drivers.length > 0) {
      <p class="p-5 subtitle">
        {{ 'PERMISSION_GRANT.heading_2' | translate }}
      </p>
    }
  </div>

  @if (drivers.length) {
    <db-panel class="drivers-container mt-5">
      <div class="db-panel__container">
        @for (driver of drivers; track driver.processorDriverId) {
          <div class="driver-container p-4 py-6">
            <db-toggleable
              label="{{driver.expandedDetails.name}}"
              leftIconName="legitimate"
              [displayLeftIcon]="true"
              iconPosition="right"
            >
              <div class="expanded">
                <div class="info-group">
                  <h4>{{ 'PERMISSION_GRANT.accordion_sec.body.desc_title' | translate }}:</h4>
                  <p>{{ 'PERMISSION_GRANT.accordion_sec.info_desc_subtext' | translate }}
                    {{ driver.processor.expandedDetails.name }}</p>
                </div>

                <div class="info-group">
                  <h4>{{ 'PERMISSION_GRANT.accordion_sec.body.fkn_title' | translate }}</h4>
                  @if (driver?.identities.length) {
                    <ul>
                      @for (identity of driver.identities; track identity.identityValue) {
                        <li>{{ identity.identityValue }}</li>
                      }
                    </ul>
                  }
                </div>

                <div class="info-group">
                  <h4>{{ 'PERMISSION_GRANT.accordion_sec.body.web_title' | translate }}</h4>
                  <p><a href="{{driver.expandedDetails.url}}">{{ driver.expandedDetails.url }}</a></p>
                </div>

                <div class="info-group">
                  @if (driver.scopes?.length) {
                    <h4>
                      {{
                        'PERMISSION_GRANT.accordion_sec.body.consents_title'
                          | translate
                      }}:</h4>
                  }
                  @if (driver.scopes?.length) {
                    <ng-container>
                      @for (scope of (driver?.scopes | dedupeByProperty:'scopeLabel'); track scope.scopeLabel) {
                        <div>
                          @if (scope.expandedDetails && scope.expandedDetails.description) {
                            <div>
                              @for (desc of (scope.expandedDetails.description | dedupeByProperty:'language'); track desc.language) {
                                <div>
                                  @if (desc.language === getActiveLang()) {
                                    <ul>
                                      <li>{{ desc.displayText }}</li>
                                    </ul>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </ng-container>
                  }
                </div>
              </div>
            </db-toggleable>
            <db-button class="revoke-button" size="xs" design="secondary"
                       (click)="onRevokeButtonClick(driver.processorDriverId, driver.expandedDetails.name)"
                       (keydown.enter)="onRevokeButtonClick(driver.processorDriverId, driver.expandedDetails.name)">
              {{ 'PERMISSION_GRANT.accordion_sec.header.revoke_access' | translate }}
            </db-button>
          </div>
        }
      </div>
    </db-panel>
  } @else {
    <div class="no-content-border no-content">
      <img src="./assets/images/eye-off.png" alt="">
      <h6 class="ms-4">{{ 'PERMISSION_GRANT.permission_not_granted' | translate }}</h6>
    </div>
  }
} @else {
  <div class="no-content">
    <db-spinner></db-spinner>
  </div>
}

<ng-template #modalTemplate>
  <db-modal-header-default title="{{modalInfo.modalTitle}}" (close)="closeModal()"></db-modal-header-default>
  <db-modal-content-default>
    <p>{{ modalInfo.modalBody }}</p>
  </db-modal-content-default>
  <db-modal-footer-default class="sticky-bottom p-0" buttonPosition="center">
    <div class="modal-footer-container">
      <db-button
        design="secondary"
        [disabled]="loadingRevoke"
        (click)="closeModal()"
        (keydown.enter)="closeModal()">{{ modalInfo.activeBtnText }}</db-button>
      <db-button
        design="primary"
        [loading]="loadingRevoke"
        (click)="revokeProcessorDriverConsents()"
        (keydown.enter)="revokeProcessorDriverConsents()">{{ modalInfo.inactiveBtnText }}
      </db-button>
    </div>
  </db-modal-footer-default>
</ng-template>
